import AutoAwesome from "@mui/icons-material/AutoAwesome";
import { styled } from "@mui/material/styles";

/**
 * Only the colour is set here. `fontSize` is deliberately not: it is an MUI size
 * token, and writing it into CSS turned it into the same-named absolute-size
 * keyword — so the icon was sized by the browser's keyword table (13/16/18px)
 * rather than by the design system, and `large` came out smaller than MUI's
 * `small`. Passing the prop through leaves sizing to `SvgIcon`, where callers
 * can still override it with `sx`.
 */
export const SparkleIcon = styled(AutoAwesome)(({ theme }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[400] : theme.palette.grey[500],
}));
